export default class InfoSummary extends HTMLElement {

    constructor() {
        super();
        this.hotel = JSON.parse(this.getAttribute('hotel'));
        this.stylesheet = this.getAttribute('stylesheet');
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#info-summary');
        this.instance = t.content.cloneNode(true);
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this.instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = '';
        });
        if (!this.hotel.is_superior) {
            this.instance.querySelector('.hotel-superior').style.display = 'none';
        }
        this._fillCategory('keys', this.hotel.keys);
        this._fillCategory('stars', this.hotel.stars);
        if (this.hotel.services.hotel_services.length !== 0 || this.hotel.services.room_services.length !== 0) {
            let highlightedServices = this._fillServices(this.hotel.services);
            if (highlightedServices) {
                let moreServicesElement = this.instance.querySelector('[name="service-link"]');
                moreServicesElement.classList.add('service-link');
                moreServicesElement.innerHTML =
                    this.hotel.services.translations.hotel_services_collapse_text.hotel_services_see_more;

                const menuSticky = document.querySelector('menu-sticky');
                let serviceGroup = this.instance.querySelector('.services-group');
                serviceGroup.addEventListener('click', () => {
                    document.querySelector('#services-container').scrollIntoView({behavior: 'smooth'});
                });
                moreServicesElement.addEventListener('click', () => {
                    document.querySelector('#services-container').scrollIntoView({behavior: 'smooth'});
                });
            }

        } else {
            this.instance.querySelector('.service-container').classList.add('hide-services');
        }

        this._shadowRoot.appendChild(this.instance);
    }

    setSnowGuarantee(snowGuarantee) {
        if (snowGuarantee) {
            this.snowGuarantee =  snowGuarantee;
            this._shadowRoot.querySelector('[name="snow-warranty-container"]').classList.add('snow-warranty-container');
            this._shadowRoot.querySelector('[name="snow-warranty-text"]').innerHTML = this.snowGuarantee;
        }
    }

    _fillCategory(name, number) {
        const categoryTemplate = this.instance.querySelector('[name="' + name + '"]');
        const hotelCategoryContainer = this.instance.querySelector('[name="hotelCategory"]');
        if (!this._checkElementExists(categoryTemplate) || !this._checkElementExists(hotelCategoryContainer)) {
            return;
        }

        for (let i = 0; i < number; i++) {
            let clonedCategory = categoryTemplate.cloneNode(true);
            hotelCategoryContainer.appendChild(clonedCategory)
        }
        categoryTemplate.remove();
    }

    _fillServicesIcon(service, serviceElements) {
            let icon = service.querySelector('i');
            let popoverText = service.querySelector('.popover-text');
            let serviceText = serviceElements.services.map(function (service) {
                return service.title;
            });

            if (this._checkElementExists(serviceElements.icon)) {
                icon.classList.add(`ci-${serviceElements.icon}`, 'ci-s-32');
            }

            if (this._checkElementExists(serviceText)) {
                popoverText.innerHTML = serviceText.join('<br>');
            } else {
                popoverText.innerHTML = '';
            }

            return service;
    }

    _fillServices(services) {
        let highlightedServices = false;

        const serviceGroup = this.instance.querySelector('[name="service-group"]');
        if (!this._checkElementExists(serviceGroup)) {
            return;
        }

        serviceGroup.innerHTML = '';
        let serviceTemplate = document.querySelector('#hotel-highlighted-service-template').content;

        if (this._checkElementExists(this.hotel.services)) {
            if (this._checkElementExists(this.hotel.services.hotel_services)) {
                this.hotel.services.hotel_services.forEach((serviceCategory, index) => {
                    if (serviceCategory.highlightedServices) {
                        let clonedService = serviceTemplate.cloneNode(true);
                        serviceGroup.appendChild(this._fillServicesIcon(clonedService, serviceCategory));
                        highlightedServices = true;
                    }
                });
            }

            if (this._checkElementExists(this.hotel.services.room_services)) {
                this.hotel.services.room_services.forEach((serviceCategory, index) => {
                    if (serviceCategory.highlightedServices) {
                        let clonedService = serviceTemplate.cloneNode(true);
                        serviceGroup.appendChild(this._fillServicesIcon(clonedService, serviceCategory));
                        highlightedServices = true;
                    }
                });
            }
        }
        return highlightedServices;
    }

    _checkElementExists(element) {
        if (typeof element !== 'undefined' && element) {
            return true;
        }
        return false;
    }
}
